import * as React from 'react';
import flatMap from 'lodash/flatMap';
import { func, number, node } from 'prop-types';
import MenuLabel from './MenuLabel';
import MenuItem from './MenuItem';
import MenuSublevel from './MenuSublevel';
import { Stack } from '../Layout';
import useControlProp from '../../hooks/useControlProp';
import MenuDivider from './MenuDivider';

const Menu = ({ children, sublevel: sublevelProp, onSublevelChange }) => {
  const [sublevel, setSublevel] = useControlProp(sublevelProp, onSublevelChange, null);
  const childArray = flatMap(React.Children.toArray(children), (child) =>
    child.type === React.Fragment ? React.Children.toArray(child.props.children) : child,
  );

  return (
    <Stack gap="none">
      {sublevel === null || !childArray[sublevel] ? (
        childArray.map((child, i) =>
          child.type === MenuSublevel
            ? React.cloneElement(child, { onSelect: () => setSublevel(i), key: i.toString() })
            : React.cloneElement(child, { key: i.toString() }),
        )
      ) : (
        <React.Fragment>
          {childArray[sublevel].props.showSubLevelLabel && (
            <MenuLabel>{childArray[sublevel].props.label}</MenuLabel>
          )}
          {childArray[sublevel].props.children}
        </React.Fragment>
      )}
    </Stack>
  );
};

Menu.propTypes = {
  children: node.isRequired,
  sublevel: number,
  onSublevelChange: func,
};

Menu.Item = MenuItem;
Menu.Label = MenuLabel;
Menu.Sublevel = MenuSublevel;
Menu.Divider = MenuDivider;

export default Menu;
